
/**
 * Mobile step menu for Bootstrap
 */
class MobileStepMenu {

	constructor() {
		this.init();

		this.desktopCanvasTitle = $('.offcanvas-header > .offcanvas-title').text();
		this.mobileCanvasTitle = $('.mobile-header > a').text();

		this.desktopLastLinkExpanded = '';
		this.mobileLastLinkExpanded = '';
	}

	init() {
		$ = jQuery;
		const self = this;

		// Fix autoclose
		$(window).on("resize", function () {
			if ($(window).width() <= 900) {
				$('#header-primary li a.dropdown-toggle').attr('data-bs-auto-close', 'false');
			} else {
				$('#header-primary li a.dropdown-toggle').attr('data-bs-auto-close', 'true');
			}

			var dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'))
			var dropdownList = dropdownElementList.map(function (dropdownToggleEl) {
				return new bootstrap.Dropdown(dropdownToggleEl)
			})
		}).resize();

		// Adjust pm height
		$('.side-menu').on('click', function (e) {
			e.preventDefault();

			let headerHeight = $('#site-header').outerHeight();
			$('.offcanvas-header').css('height', headerHeight + 'px');
		});

		// Close pm menu
		$('[data-bs-dismiss="mobile-header"]').on('click', function (e) {
			e.preventDefault();
			$('#primary_menu_toggle').trigger('click');
		});

		// Offcanvas title <back>
		$(document).on('click', '.offcanvas-header > a, .mobile-header > a', function (e) {
			var $header = $(this).parent();

			if (!$header.hasClass('active'))
				return true;

			e.preventDefault();

			if ($header.hasClass('offcanvas-header')) {
				var $lastLink = self.desktopLastLinkExpanded;

				$lastLink.removeClass('show');
				$lastLink.find('.dropdown-menu, .dropdown, .dropdown-toggle').removeClass('show');

				self.desktopLastLinkExpanded = $lastLink.closest('.dropdown.show');

				if (!self.desktopLastLinkExpanded.length) {
					$(this).removeClass('active');
					$('.offcanvas-header > .offcanvas-title').html(self.desktopCanvasTitle);
				} else {
					let linkText = self.desktopLastLinkExpanded.find('> a').text();
					let arrow = '<b class="arrow light left"></b>';

					$('.offcanvas-header').addClass('active');
					$('.offcanvas-header > .offcanvas-title').html(arrow + linkText);
				}
			} else if ($header.hasClass('mobile-header')) {
				var $lastLink = self.mobileLastLinkExpanded;

				$lastLink.removeClass('show');
				$lastLink.find('.dropdown-menu, .dropdown, .accordion-collapse, .dropdown-toggle').removeClass('show');

				self.mobileLastLinkExpanded = $lastLink.closest('.dropdown.show');

				if (!self.mobileLastLinkExpanded.length) {
					$(this).removeClass('active');
					$('.mobile-header > a').html(self.mobileCanvasTitle);
				} else {
					let linkText = self.mobileLastLinkExpanded.find('> a').text();
					let arrow = '<b class="arrow light left"></b>';

					$('.mobile-header').addClass('active');
					$('.mobile-header > a').html(arrow + linkText);
				}
			}
		});


		// Combined step-events
		$(document).on('click', '#site-header .step-menu li.dropdown.menu-item-has-children, #site-header .step-menu-mobile li.dropdown.menu-item-has-children', function (e) {

			// Mobile
			if ($(this).hasClass('walker-nav')) {

				var depth2 = $(this).find(" ul>li.depth_2");
				if(depth2){

					self.mobileLastLinkExpanded = $(this);
					let linkText = $(this).find('> a').text();
					let arrow = '<b class="arrow light left"></b>';

					$('.mobile-header').addClass('active');
					$('.mobile-header > a').html(arrow + linkText);

					$(this).toggleClass('show');

					return true;
				}

				// Break on main menu
				if ($(window).width() >= 900) {
					return true;
				} else {
					
					e.preventDefault();
					e.stopPropagation();

					$(this).toggleClass('show');

					self.mobileLastLinkExpanded = $(this);

					let linkText = $(this).find('> a').text();
					let arrow = '<b class="arrow light left"></b>';

					$('.mobile-header').addClass('active');
					$('.mobile-header > a').html(arrow + linkText);

					// Remove show on siblings
					$(this).next().nextAll('.dropdown-menu, .dropdown, .accordion-collapse, .dropdown-toggle').removeClass('show');
				}

				return;
			}

			// Canvas
			e.preventDefault();
			e.stopPropagation();

			$(this).toggleClass('show');

			self.desktopLastLinkExpanded = $(this);

			let linkText = $(this).find('> a').text();
			let arrow = '<b class="arrow light left"></b>';

			$('.offcanvas-header').addClass('active');
			$('.offcanvas-header > .offcanvas-title').html(arrow + linkText);

			if (!$(e.target).hasClass('dropdown-toggle')) {
				window.location.href = $(e.target).attr('href');
				return true;
			}

			// Remove show on siblings
			$(this).find('.dropdown-menu').nextAll('.dropdown-menu, .dropdown, .dropdown-toggle').removeClass('show');
		});
	}
}

export default MobileStepMenu;
